import { CommonModule } from '@angular/common';
import { HttpClientJsonpModule, HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { DaButtonModule } from '../da-button';
import { DaLinkModule } from '../da-link';
import { FormBuilderModule } from '../form-builder';
import { HubspotComponent } from './hubspot.component';
import { HubspotTrackingService } from './shared/services/hubspot-tracking.service';
import { HubspotService } from './shared/services/hubspot.service';
import { PrepopulationHandlingService } from './shared/services/prepopulation-handling.service';

@NgModule({
    declarations: [HubspotComponent],
    imports: [
        CommonModule,
        HttpClientJsonpModule,
        HttpClientModule,
        ReactiveFormsModule,
        FormsModule,
        FormBuilderModule,
        TranslateModule,
        DaButtonModule,
        DaLinkModule
    ],
    providers: [HubspotService, PrepopulationHandlingService, HubspotTrackingService],
    exports: [HubspotComponent]
})
export class HubspotModule {}
